import { PrismicRichText } from '@prismicio/react';
import { ReactElement, useRef } from 'react';

import {
  Accordion,
  AccordionItem,
  IAccordionRefObject,
} from '@components/atoms/Accordion';
import { SliceAccordionContent } from './SliceAccordionContent';

import { IProps } from './types';
import * as S from './styles';

export function SliceProductDetails({
  slice: { primary, fields },
}: IProps): ReactElement {
  const accordionRef = useRef<IAccordionRefObject>(null);

  return (
    <S.Wrapper className="slice-product-details">
      <S.Padding>
        {primary.title && (
          <S.Title className="blue">
            <PrismicRichText field={primary.title} />
          </S.Title>
        )}
        {fields && (
          <Accordion
            ref={accordionRef}
            multi
            expanded={[...Array(fields.length).keys()]}
          >
            {fields.map((item, i) => (
              <AccordionItem
                title={item.title && <PrismicRichText field={item.title} />}
                uniqueKey={i}
                key={`slice-accordion-item-${i}`}
              >
                <SliceAccordionContent item={item} />
              </AccordionItem>
            ))}
          </Accordion>
        )}
      </S.Padding>
    </S.Wrapper>
  );
}

SliceProductDetails.componentName = 'product_details';
